import React from "react";
import BaseCard, { BaseCardListItem } from "components/BaseCard";
import { useNavigation } from "@react-navigation/native";
import i18n from "plugins/localization";

interface GuestPassesProps {
  groupCode: string;
}

const GuestPasses: React.FC<GuestPassesProps> = (props) => {
  const { groupCode } = props;
  const navigation = useNavigation<any>();

  const toGuestsScreen = () => navigation.push("Guests", { groupCode });

  return (
    <BaseCard title={i18n.t("screens.EventDetail.guestPassesTitle")}>
      <BaseCardListItem
        title={i18n.t("screens.EventDetail.manageGuests")}
        onPress={toGuestsScreen}
      ></BaseCardListItem>
    </BaseCard>
  );
};

export default GuestPasses;
